// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
      apiKey: "AIzaSyBnYdfxDJ5866WHabwrbToKZN7gTUe4wRw",
      authDomain: "hp-race.firebaseapp.com",
      databaseURL: "https://hp-race.firebaseio.com",
      projectId: "hp-race",
      storageBucket: "hp-race.appspot.com",
      messagingSenderId: "479186612041",
      appId: "1:479186612041:web:f1826b801885adca28b498",
      measurementId: "G-L0Y5TSVHFJ"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
